import { render, staticRenderFns } from "./BuildingUsage.vue?vue&type=template&id=61938746&scoped=true"
import script from "./BuildingUsage.vue?vue&type=script&lang=js"
export * from "./BuildingUsage.vue?vue&type=script&lang=js"
import style0 from "./BuildingUsage.vue?vue&type=style&index=0&id=61938746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61938746",
  null
  
)

export default component.exports